import React from 'react';

import * as S from './styles';

function Smile() {
  return <S.Iosmile />;
}

export default Smile;